import React, { useContext } from 'react'
import CommonBox from './components/CommonBox'
import GifImagesSection from './components/GifImagesSection'
import CustomerSection from './components/CustomerSection'
import LoginContext from './context'

const Customer = () => {
    const { isAuthenticated } = useContext(LoginContext);

    return (
        <>
            <section className='customer-section'>
                <CommonBox heading="고객센터" englishHeading="customer center" isEnglishHeadingOnMobile={true} isAuthenticated={isAuthenticated}>
                    <CustomerSection />
                </CommonBox>
            </section>
            <section className='gif-section flex lg:hidden items-center justify-center'>
                <GifImagesSection />
            </section>
        </>
    )
}

export default Customer